export const ReportSecondaryTabs = {
  Transactions: 'Transactions',
  AccountsBalance: 'Accounts Balance',
} as const;
export type ReportSecondaryTabs = (typeof ReportSecondaryTabs)[keyof typeof ReportSecondaryTabs];
